module.exports = __webpack_public_path__ + "img/clock.a75aeb26.svg";